import PrevIcon from './component'

export default PrevIcon
